import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './why-trust-us.css';
import { FaShieldAlt, FaUserCheck, FaRupeeSign, FaStar } from 'react-icons/fa';

const WhyTrustUs = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  const trustPoints = [
    {
      icon: <FaShieldAlt className="why-icon" />,
      title: 'Secure & Private',
      desc: 'We use bank-level encryption to keep your data safe and confidential.',
      delay: 0,
    },
    {
      icon: <FaUserCheck className="why-icon" />,
      title: 'Trusted by Thousands',
      desc: 'Over 50,000 salaried professionals trust us with their urgent financial needs.',
      delay: 100,
    },
    {
      icon: <FaRupeeSign className="why-icon" />,
      title: 'Instant Disbursal',
      desc: 'Get money in your bank within hours of approval. No delays.',
      delay: 200,
    },
    {
      icon: <FaStar className="why-icon" />,
      title: 'Process with full Transparency',
      desc: 'No hidden charges, no surprises — just clear terms you can rely on.',
      delay: 300,
    },
  ];

  return (
    <section className="why-section py-4">
      <div className="container">
        <h6 className="why-subtitle text-center" data-aos="fade-up">
          Why Trust Us
        </h6>

        <h2 className="why-choose-title text-center mb-4" data-aos="fade-up" data-aos-delay="100">
          Your <span className="highlight">Reliable Financial </span> Partner
        </h2>

        <p className="why-desc text-center mb-5" data-aos="fade-up" data-aos-delay="200">
          We make borrowing safe, simple, and stress-free. Here's why thousands trust us.
        </p>

        <div className="row g-4">
          {trustPoints.map((point, index) => (
            <div
              className="col-md-6 col-lg-3"
              key={index}
              data-aos="fade-up"
              data-aos-delay={point.delay}
            >
              <div className="why-box text-center">
                {point.icon}
                <h4>{point.title}</h4>
                <p>{point.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyTrustUs;
